module.exports = __webpack_public_path__ + "h5/img/master_5.6b31b30f.jpg";